<script>
  export let value = null
  export let label = value || ''
  export let hidden = false
  export let disabled = false

  import { getContext } from 'svelte'
  const element = getContext('currentElement')
</script>

<option {value} {disabled} {hidden} class:selected={$element.value === value}>{label}</option>
